export default __webpack_public_path__ + "static/img/11.f426938.png";